/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type Tile_item$ref = any;
export type PdpRespSimilarItem_item$ref = any;
export type PdpRespSimilarItem_item = {
    readonly serviceId: string | null;
    readonly isFurniture: boolean | null;
    readonly " $fragmentRefs": Tile_item$ref;
    readonly " $refType": PdpRespSimilarItem_item$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespSimilarItem_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade",
      "type": null
    }
  ],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isFurniture",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "Tile_item",
      "args": [
        {
          "kind": "Variable",
          "name": "isTrade",
          "variableName": "isTrade"
        }
      ]
    }
  ]
};
(node as any).hash = 'a0fa664660d2bcd339f2fdf4ce68f638';
export default node;
